<template>
  <div id="intro">
      <home-slider :error="error" :show="show" :data="info" />
  </div>
</template>

<script>

import HomeSlider from '../../components/sliders/HomeSlider'
import HomeSliderRepository from '../../repositories/HomeSliderRepository'
import gc from '../../utils/gc'
export default {
  name: 'Intro',
  components: { HomeSlider },
  data () {
    return {
      homeSliderRepo: new HomeSliderRepository(),
      info: [],
      show: false,
      error: false
      // test: ''
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        const response = await this.homeSliderRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.data.length; i++) {
            this.info.push({ title: response.data.data[i].title, description: response.data.data[i].description, image: gc.baseUrl + '/customerCare' + response.data.data[i].largeImage, smallImage: gc.baseUrl + '/customerCare' + response.data.data[i].smallImage, link: response.data.data[i].link })
          }
          this.show = true
        } else {
          this.show = false
          this.error = true
        }
      } catch (e) {
        this.show = false
        this.error = true
      }
    }
  }
}
</script>

<style scoped>
.home-section{
  height: 100vh;
}
</style>
